<script>
/**
 * @component TrackingNav
 * @description Barra de tabs compartida entre Seguimientos, Protocolos y Configuración de tareas.
 * @example <TrackingNav active="seguimientos" />
 */
export default {
  name: "TrackingNav",

  props: {
    /** @type {'seguimientos'|'protocolos'|'configuracion'} Tab activa */
    active: {
      type: String,
      required: true,
      validator: (v) =>
        ["seguimientos", "protocolos", "configuracion"].includes(v),
    },
  },

  methods: {
    /**
     * Navega a la ruta de configuración de tipo de tarea seleccionada.
     * @param {string} routeName - Nombre de la ruta (ej: 'treatment-vital')
     */
    goToConfig(routeName) {
      this.$router.push({ name: routeName });
    },
  },
};
</script>

<template lang="pug">
.tracking-nav
  router-link.tracking-nav__tab(
    :to="{ name: 'dashboard-alerts' }"
    :class="{ 'tracking-nav__tab--active': active === 'seguimientos' }"
  )
    span Seguimientos
  router-link.tracking-nav__tab(
    :to="{ name: 'treatment' }"
    :class="{ 'tracking-nav__tab--active': active === 'protocolos' }"
  )
    span Protocolos
  el-dropdown.tracking-nav__dropdown(trigger="click" @command="goToConfig")
    a.tracking-nav__tab(
      :class="{ 'tracking-nav__tab--active': active === 'configuracion' }"
    )
      span Configuración
      i.el-icon-arrow-down.tracking-nav__arrow
    el-dropdown-menu(slot="dropdown")
      el-dropdown-item(command="treatment-medication") Medicaciones
      el-dropdown-item(command="treatment-appointment") Recordatorios
      el-dropdown-item(command="treatment-recommendation") Recomendaciones
      el-dropdown-item(command="treatment-exercise") Ejercicios
      el-dropdown-item(command="treatment-vital") Registros
      el-dropdown-item(command="treatment-report") Reportes
      el-dropdown-item(command="treatment-checkin") Check-in
</template>

<style lang="scss" scoped>
.tracking-nav {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #e2e8f0;
  padding: 0 24px;
  margin-bottom: 20px;
}

.tracking-nav__tab {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #94a3b8;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    color: #475569;
  }
}

.tracking-nav__tab--active {
  color: #002d5e;
  font-weight: 600;
  border-bottom-color: #002d5e;
}

.tracking-nav__dropdown {
  display: inline-flex;
}

.tracking-nav__arrow {
  font-size: 12px;
  margin-left: 2px;
}
</style>
